import React, { useState, useContext } from 'react'
import { DarkModeContext } from '../../global/Theme'
import { useSelector } from 'react-redux'

import './index.sass'
import { useHistory } from 'react-router-dom'


export default function LegalDesktopHeader({ title }) {
    const { isDark } = useContext(DarkModeContext);

    const user = useSelector(state => state.isLoggedIn);


    const history = useHistory();

    const goBackSimonHaha = () => {
        history.goBack()
        //history.goBack()

    }


    return (
        <div className={`legal-desktop-header ${isDark ? 'legal-dark' : 'legal-light'}`}>
            <div className='legal-header-col-left'>
                <img onClick={goBackSimonHaha} src={require('../../assets/icons/backbutton.svg')} />
                <h1>{title}</h1>
            </div>

            { !user && <div className='legal-header-col-right'>
                <div className='btn-opaque'>
                    REGISTER
            </div>

                <div className='btn-filled'>
                    LOGIN
                </div>

            </div>
            }

        </div>
    )
}
